import React from 'react';

import Process from '../Process';

import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

const processes = [
  {
    index: 1,
    title: 'Starting Point',
    text: 'After receiving your request, within 24 hours our account manager will reach you, present the proposal structure and deadline. The more information you provide about-us-new your needs and business, the more extended and targeted offers we will be able to provide. The information provided by you is 100%  confidential.',
  },
  {
    index: 2,
    title: 'Custom proposal creation',
    text: 'Our specialists create a custom proposal based on our research and the provided information, which includes SM pages audit, competitive analysis, our main proposal, the scope of work, budget. This will give you an idea of your current SM presence from a different perspective and an overview of the team’s assistance.',
  },
  {
    index: 3,
    title: 'Project confirmation',
    text: 'During the kick-off meeting, our specialists present the proposal and answer all the questions you may have. Simultaneously, you get acquainted with the on-working team. After your final approval, we move on to the strategy development phase.',
  },
  {
    index: 4,
    title: 'Goal setting & strategy creation',
    text: 'We send a questionnaire, on account of which we get a better idea of your business goals. After analyzing your target audience, our specialists will create a custom SM strategy, in accordance with it your future content plan and SM activities will be built.',
  },
  {
    index: 5,
    title: 'Content creation & curation',
    text: 'At this stage, the production team creates 100% custom images and videos. The content writer works on the text section, then we send a content calendar, where you see what will be published on SM according to the days of the month. Here, you have the opportunity for unlimited revisions. After the content is approved, we begin publishing it.',
  },
  {
    index: 6,
    title: 'Social media pages management',
    text: "We follow the results of SM pages daily. We respond to users’ messages and comments within 8 or fewer hours, daily monitor the page by thoroughly studying the audience, performance metrics, competitors' indicators, etc.",
  },
  {
    index: 7,
    title: 'Analytics & reporting',
    text: "We provide 100% transparency for the work done. In the monthly reports, you will find an analysis of the quantitative and qualitative indicators of the work. Based on the analysis, the upcoming month's content is created to achieve even better results.",
  },
];

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-next"
      className="arrow-next cursor-pointer absolute"
      style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" width={24} height={24} alt={'arrow'} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-prev"
      className="arrow-prev hidden cursor-pointer absolute -left-30"
      style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" width={24} height={24} alt={'arrow'} />
    </div>
  );
}

const SimpleSlider = () => {
  var settings = {
    infinite: false,
    speed: 300,
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: true,

    customPaging: function (i) {
      return <div className="custom-slick-dots" id={i}></div>;
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipe: true,
          arrows: false,
        },
      },
    ],
    afterChange: function (a, b) {
      if (a == 0) {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'none';
        }
      } else if (a == 4) {
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'none';
        }
      } else {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'block';
        }
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'block';
        }
      }

      var el = document.getElementById('process-row');

      console.log(a);

      if (el) {
        el.style.width = `${Math.min((a + 1) * (100 / (window.innerWidth > 768 ? 5 : 7)), 100)}%`;
      }
    },
  };
  return (
    <div>
      <div className="relative mb-15">
        <div className="w-full h-2 bg-gray-slider" />
        <div
          id="process-row"
          className="absolute left-0 h-4 bg-purple rounded-5 transition-all transition-500"
          style={{ top: '-1px', width: `${100 / 6}%` }}
        />
      </div>

      <Slider {...settings} className="process-slider relative z-10">
        {processes.map((process, index) => (
          <div key={index} className={(index !== 6 ? 'max-w-280' : 'max-w-none') + ' md:max-w-none mr-15 md:mr-30'}>
            <div className="relative z-10 pr-15 md:pr-23 h-full md:select-text">
              <div className="relative bg-gray-light md:bg-auto py-23 md:p-0 h-full">
                <p className="relative right-0 top-0 text-48 font-black leading-none text-gray-transparent md:text-pink pr-5 md:pr-0">
                  0{process.index}
                </p>

                <p className="text-14 lg:text-16 font-bold md:font-black text-green normal-case md:uppercase mb-23 md:mb-0  max-w-none">
                  {process.title}
                </p>

                <p className="text-14 max-w-none">
                  <span>{process.text}</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default SimpleSlider;
